/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-trash-can': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 7.5h1.25V15H7.5V7.5zm3.75 0h1.25V15h-1.25V7.5zM2.5 3.75V5h1.25v12.5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V5h1.25V3.75h-15zM5 17.5V5h10v12.5H5zM7.5 1.25h5V2.5h-5V1.25z"/>'
  }
})
